// mds-dojo — dijit/_WidgetsInTemplateMixin — FAITHFUL port of
// references/dijit/_WidgetsInTemplateMixin.js. Codemod pipeline; unused `aspect`
// import dropped; declare from the faithful runtime. Promoted to canonical.
// Supplements _TemplatedMixin when the template contains widgets: parses them before
// filling content. NOTE: relies on parser.parse(...).then() resolving SYNCHRONOUSLY
// (all supporting widgets pre-loaded — see the throw below); the mds parser must
// return a sync-resolved thenable for this (verified at integration).
import array from '../dojo/_base/array';
import declare from '../dojo/_base/declare-runtime';
import lang from '../dojo/_base/lang';
import parser from '../dojo/parser';

export default declare('dijit._WidgetsInTemplateMixin', null, {
  _earlyTemplatedStartup: false,
  contextRequire: null,

  _beforeFillContent: function () {
    // Short-circuit the parser when the template has no widgets. (Check innerHTML,
    // not templateString — data-dojo-type may arrive via a ${} substitution.)
    if (/dojoType|data-dojo-type/i.test(this.domNode.innerHTML)) {
      var node = this.domNode;

      if (this.containerNode && !this.searchContainerNode) {
        this.containerNode.stopParser = true;
      }

      parser.parse(node, {
        noStart: !this._earlyTemplatedStartup,
        template: true,
        inherited: { dir: this.dir, lang: this.lang, textDir: this.textDir },
        propsThis: this, // data-dojo-props of template widgets can reference "this"
        contextRequire: this.contextRequire,
        scope: 'dojo',
      } as any).then(lang.hitch(this, function (this: any, widgets: any[]) {
        this._startupWidgets = widgets;

        // Hook up attach points/events for nodes converted to widgets.
        for (var i = 0; i < widgets.length; i++) {
          this._processTemplateNode(widgets[i], function (n: any, p: string) {
            return n[p]; // get a property of a widget
          }, function (widget: any, type: string, callback: any) {
            // data-dojo-attach-event to a widget
            if (type in widget) {
              return widget.connect(widget, type, callback); // back-compat
            } else {
              return widget.on(type, callback, true);
            }
          });
        }

        if (this.containerNode && this.containerNode.stopParser) {
          delete this.containerNode.stopParser;
        }
      }));

      if (!this._startupWidgets) {
        throw new Error(this.declaredClass + ': parser returned unfilled promise (probably waiting for '
          + 'module auto-load), unsupported by _WidgetsInTemplateMixin. Must pre-load all supporting '
          + 'widgets before instantiation.');
      }
    }
  },

  _processTemplateNode: function (baseNode: any, getAttrFunc: any, attachFunc: any) {
    // Skip DOMNodes with data-dojo-type (handled in _beforeFillContent above).
    if (getAttrFunc(baseNode, 'dojoType') || getAttrFunc(baseNode, 'data-dojo-type')) {
      return true;
    }
    return this.inherited(arguments);
  },

  startup: function () {
    array.forEach(this._startupWidgets, function (w: any) {
      if (w && !w._started && w.startup) {
        w.startup();
      }
    });
    this._startupWidgets = null;
    this.inherited(arguments);
  },
});
